import jwtService from '@/utils/jwt'

/**
 * 交易相关的API接口
 */
class TradeService {
    /**
     * 上传零件表文件
     * @param {File} file - 要上传的文件
     * @param {string} sids - 会话ID
     * @param {Function} onProgress - 上传进度回调函数
     * @returns {Promise<any>} - API响应
     */
    uploadPartsList(file, sids, onProgress) {
        const uploadUrl = `/go2brick/analysis/upload?sids=${sids}`
        const formData = new FormData()
        formData.append('file', file)

        return jwtService.postFormData(uploadUrl, formData, {
            onUploadProgress: (progressEvent) => {
                if (progressEvent.lengthComputable && onProgress) {
                    onProgress({ percent: (progressEvent.loaded / progressEvent.total) * 100 })
                }
            }
        })
    }

    /**
     * 创建订单
     * @param {Object} orderData - 订单数据，包含零件和分套信息
     * @returns {Promise<any>} - API响应，包含订单编号(orderno)和支付二维码(wxqrcode)
     */
    getPaymentInfo(orderData) {
        return jwtService.post('/frontend/trade/order/website/preview', orderData)
    }

    /**
     * 查询订单状态
     * @param {string} orderno - 订单编号（MD5加密的订单ID）
     * @returns {Promise<any>} - API响应，包含订单支付状态（-1=未支付或匿名用户，1=已支付）
     */
    queryOrderStatus(orderno) {
        return jwtService.get('/frontend/trade/order/website/preview/sync', { orderno })
    }

    /**
     * 获取零件信息，支持不指定颜色
     * @param {string} sids - 会话ID，多个ID用逗号分隔
     * @param {string} designCode - 零件设计代码
     * @param {string} colorId - 颜色ID（可选）
     * @param {number} qty - 数量
     * @returns {Promise<any>} - API响应，包含零件信息
     */
    getPart(sids, designCode, colorId, qty) {
        const params = {
            sids: sids,
            designCode: designCode,
            qty: qty
        }

        // 只有在提供颜色ID时才添加到参数中
        if (colorId) {
            params.colorId = colorId
        }

        return jwtService.post('/go2brick/analysis/part', {}, { params })
    }
}

export default new TradeService()
